import React, { useState, useEffect, useContext } from 'react';
import { useSiteData } from 'react-static';
import { ThemeContext } from 'styled-components';
// template components
import SectionVideoPlayer from '@nmx/template/dist/componentLibrary/modules/SectionVideoPlayer';
// images
import backgroundImageDesktop from '../../../../../images/components/sectionVideoPlayer/family-running-on-beach-desktop.webp';
import backgroundImageTablet from '../../../../../images/components/sectionVideoPlayer/family-running-on-beach-tablet.webp';

export default () => {
  const { config } = useSiteData();

  const theme = useContext(ThemeContext);
  const largeDown = theme.largeDown();
  const [isLargeDown, setIsLargeDown] = useState(largeDown);

  useEffect(() => {
    if (largeDown !== isLargeDown) {
      setIsLargeDown(largeDown);
    }
  }, [largeDown, isLargeDown]);

  return (
    <SectionVideoPlayer
      backgroundImage={isLargeDown ? backgroundImageTablet.toString() : backgroundImageDesktop.toString()}
      config={config}
      playButtonSupportiveText='See how you can protect your income'
      duration='1m 11s'
      durationDisplay='1 min'
      sectionId='disability-insurance-video'
      videoId='d3unE0dB3u0'
      videoTitle='Protect Your Lifestyle with Disability Insurance'
      title={
        <>
          1 in 4 people will become disabled before age 67.<sup>1</sup>
        </>
      }
    />
  );
};
